// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"1a69ca8e7f8a638e1bbb","453":"a384f48fe015ddfb7f2d"}[chunkId] + ".js";
};